export function formDataToQueryString(data: FormData): string
{
    let parts = [];

    data.forEach((item, key) => parts.push(key + '=' + item));

    return parts.join('&');
}
